import { render, staticRenderFns } from "./MAN938M05.vue?vue&type=template&id=90703aa0&"
import script from "./MAN938M05.vue?vue&type=script&lang=js&"
export * from "./MAN938M05.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports